import { useNuxtApp } from '#app'

export const useBus = () => {
  return useNuxtApp().$eventBus
}
